import { usePage } from '@inertiajs/react'
import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { getCookieConsent, onCookieConsentReset, setCookieConsent } from '@/lib/cookie-consent'
import { privacy_path } from '@/routes'

export function CookieConsentBanner() {
  const { props } = usePage<{ nav?: unknown }>()
  const signedOut = !props.nav

  // Starts hidden on both server and first client render (no hydration
  // mismatch) — document.cookie doesn't exist during SSR, so the real check
  // has to happen after mount.
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(signedOut && getCookieConsent() === null)
  }, [signedOut])

  // The "Cookie preferences" link in the page footers is a separate
  // component tree (per-page, not mounted in AppShell) — this is how it
  // tells this banner to reappear after clearing the stored decision.
  useEffect(() => onCookieConsentReset(() => setVisible(signedOut)), [signedOut])

  if (!visible) return null

  const decide = (value: 'accepted' | 'declined') => {
    setCookieConsent(value)
    setVisible(false)
  }

  return (
    <div className="fixed bottom-6 left-6 z-50 w-[min(22rem,calc(100vw-3rem))] rounded-xl border border-border bg-card p-5 shadow-lg">
      <div className="flex items-start gap-3">
        <span className="text-2xl leading-none" aria-hidden>🍪</span>
        <div>
          <h2 className="font-display text-sm font-bold text-foreground">We use cookies</h2>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
            Just optional, anonymous analytics on this page — nothing tracks you once you're signed in. Details in
            our{' '}
            <a href={privacy_path()} className="underline underline-offset-2 hover:text-foreground">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-col gap-2">
        <Button size="sm" className="w-full" onClick={() => decide('accepted')}>Accept</Button>
        <Button variant="outline" size="sm" className="w-full" onClick={() => decide('declined')}>Decline</Button>
      </div>
    </div>
  )
}
